import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs } from 'react-bootstrap';
import moment from 'moment';
import TimeChart from './TimeChart';
import DealSizeChart from './DealSizeChart';
import AccountSizeChart from './AccountSizeChart';
import IndustryChart from './IndustryChart';


import styles from './styles.css';

const items = [
  { title: 'Time', id: 'time', component: TimeChart },
  { title: 'Deal Size', id: 'dealSize', component: DealSizeChart },
  { title: 'Account Size', id: 'accountSize', component: AccountSizeChart },
  { title: 'Industry', id: 'industry', component: IndustryChart },
];

const USER_PREFERENCE_SELECTED_TAB = 'leaderboard-chart-selected-tab';


class Charts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'time',
    };
    this.handleSelectTab = this.handleSelectTab.bind(this);
  }

  componentWillMount() {
    const activeTab = this.context.getUserPreference(USER_PREFERENCE_SELECTED_TAB, 'time');
    this.setState({ activeTab });
  }

  handleSelectTab(activeTab) {
    this.setState({ activeTab });
    this.context.updateUserPreference(USER_PREFERENCE_SELECTED_TAB, activeTab);
  }

  render() {
    const { activeTab } = this.state;
    const { closeDateRange } = this.props;
    return (
      <div className={styles.graphWrapper}>
        <div className="container">
          <Tabs
            mountOnEnter
            unmountOnExit
            animation={false}
            activeKey={activeTab}
            onSelect={this.handleSelectTab}
            id="charts-tab"
          >
            {items.map(item => (
              <Tab
                eventKey={item.id}
                title={item.title}
              >
                <div>
                  <item.component closeDateRange={closeDateRange} onOpportunitySelect={this.props.onOpportunitySelect} />
                </div>
              </Tab>))}
          </Tabs>
        </div>
      </div>
    );
  }
}


Charts.propTypes = {
  closeDateRange: PropTypes.arrayOf(PropTypes.instanceOf(moment)),
  onOpportunitySelect: PropTypes.func,
};

Charts.defaultProps = {
  closeDateRange: [],
  onOpportunitySelect: () => {},
};

Charts.contextTypes = {
  updateUserPreference: PropTypes.func.isRequired,
  getUserPreference: PropTypes.func.isRequired,
};
export default Charts;
